import React from "react";
import ScaledLogo from "./ScaledLogo";
import styles from "./materials.module.scss";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-GB", { month: "long" });
  return `${day}. ${month}`;
};

const Banner = ({ event, textColor, bgColor, variant = "meetup", titleFontSize, speakerFontSize }) => {
  const isLinkedIn = variant === "linkedin";
  const titleStyle = titleFontSize ? { fontSize: `${titleFontSize}px` } : undefined;
  const speakerStyle = speakerFontSize ? { fontSize: `${speakerFontSize}px` } : undefined;

  return (
    <div className={styles.banner} style={{ "--mat-bg": bgColor, "--mat-text": textColor }}>
      <div className={styles.bannerTextContainer}>
        <span className={styles.bannerLabel}>Meetup #{event.eventMeetupNo}</span>
        <span className={styles.bannerTitle} style={titleStyle}>{event.eventName}</span>
      </div>
      <div className={isLinkedIn ? styles.bannerLogoTopRight : styles.bannerLogoBottomRight}>
        <ScaledLogo color={event.color} width={192} height={221} />
      </div>
      <div className={isLinkedIn ? styles.bannerSpeakersLinkedin : styles.bannerSpeakers}>
        {event.speakers?.map((speaker, i) => (
          <div key={i} className={styles.bannerSpeakerCol}>
            <p className={styles.bannerSpeakerName} style={speakerStyle}>{speaker.name}</p>
            <p className={styles.bannerSpeakerDetail} style={speakerStyle}>{speaker.title}</p>
            <p className={styles.bannerSpeakerDetail} style={speakerStyle}>{speaker.businessName}</p>
          </div>
        ))}
      </div>
      {isLinkedIn && (
        <div className={styles.bannerDateTime}>
          <p>{formatDate(event.date)}</p>
          <p>kl. {event.timeFrom}</p>
        </div>
      )}
    </div>
  );
};

export default Banner;
